import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { ProgressBox } from '@bvt-atoms';
import './CardReligion.scss';
import DynamicIcon from '@bvt-icons';
import _ from 'lodash';
import { BaseCard } from '@bvt-shared/component/BaseCard';
import { generateUUID } from '@bvt-utils';

/**
 * @param {object} props
 * @param {Object} IReligionData
 * @param {Array<IReligionData>} props.data
 */

/**
 * @author Renta <renta.yustika@bvarta.com>
 * @copyright PT Bhumi Varta Technology
 * @param {...IReligionData} props
 */
export default function Religion(props) {
  const { data, style, isLoading } = props;
  const [filteredData, setFilteredData] = useState(data);
  const [checked, setChecked] = useState(_.map(data, (v) => v.type));

  const handleChangeReligion = (_item) => {
    if (checked.includes(_item.type)) {
      setChecked(_.filter(checked, (v) => v !== _item.type));
    } else {
      setChecked(_.concat(checked, _item.type));
    }
  };

  useEffect(() => {
    let tempReligion = [];
    tempReligion = _.map(checked, (v) => {
      return _.concat(
        ...tempReligion,
        _.filter(data, (w) => w.type === v)[0]
      )[0];
    });
    setFilteredData(tempReligion);
  }, [checked, data]);

  return (
    <div id={props.id} style={style}>
      <BaseCard isLoading={isLoading} title='Religion' withPadding={true}>
        <div className='step-result--religion-body'>
          <ProgressBox data={filteredData} round={true} />
          <div className='step-result--religion-body-legend'>
            {data.map((item) => {
              return (
                <label
                  className='form-control-legend'
                  key={generateUUID()}
                  style={{ '--Color-Religion': item.color }}
                >
                  <div
                    className={`custom-checkbox ${checked.includes(item.type) ? 'checked' : ''}`}
                    onClick={() => handleChangeReligion(item)}
                  />
                  {item.type}
                </label>
              );
            })}
          </div>
        </div>
        <div className='step-result--religion-footer'>
          <div className='step-result--religion-footer-content'>
            <DynamicIcon
              className='step-result--religion-footer-info'
              height='1rem'
              icon='info'
              width='1rem'
            />
            Select and click to do comparison
          </div>
        </div>
      </BaseCard>
    </div>
  );
}

Religion.propTypes = {
  data: PropTypes.array,
};

Religion.defaultProps = {
  data: [
    { type: 'Islam', value: 40, color: '#006C64' },
    { type: 'Budha', value: 9, color: '#33CC99' },
    { type: 'Catholic', value: 20, color: '#FF9966' },
    { type: 'Confucianism', value: 1, color: '#FF0066' },
    { type: 'Hindu', value: 20, color: '#FFCC00' },
    { type: 'Protestant', value: 10, color: '#00A8FF' },
    { type: 'Others', value: 0, color: '#A1ADBB' },
  ],
};
